@if (banner && !wasClosed && !isLoggedIn) {
    <div class="pop-up-banner d-flex flex-column align-items-center justify-content-center" (click)="close()">
        <a (click)="close()" class="pop-up-banner-close app-cursor">{{ 'web.close' | translate | transinit }}</a>
        <div class="pop-up-banner-child">
            @if (banner.url) {
                <a
                    target="_blank"
                    href="{{ banner.url }}{{ utm(banner.url) }}"
                    (click)="click(); close()"
                    [id]="bannerPositionId + ' | ' + banner.url"
                    class="app-banner-main"
                >
                    <img
                        src="{{ banner.path }}"
                        class="banner"
                        fetchpriority="high"
                        alt="{{ banner.altText }}"
                        srcset="{{ banner.small_image }} 600w,
                        {{ banner.medium_image }} 1024w,
                        {{ banner.large_image }} 1600w"
                        class="pop-up-banner__image"
                    />
                </a>
            } @else {
                @if (!banner.url) {
                    <img
                        src="{{ banner.path }}"
                        class="banner"
                        fetchpriority="high"
                        alt="{{ banner.altText }}"
                        srcset="{{ banner.small_image }} 600w,
                        {{ banner.medium_image }} 1024w,
                        {{ banner.large_image }} 1600w"
                        class="pop-up-banner__image"
                    />
                }
            }
        </div>
    </div>
}
